
<form class="k-form">
  <div>
    <app-alert></app-alert>
  </div>
  <ngl-tabset [(selected)]="selectedTab" type="scoped">
    <ng-template ngl-tab id="barKeywords" label="BAR Keywords">
      <div>
        <label for="bar-keywords" class="k-form-field">
          <input id="bar-keywords" name="bar-keywords" type="text" [(ngModel)]="barKeywords" />
        </label>
      </div>
      <p class="help-block">Enter comma separated keywords and phrases (max 1024 characters) ex. BEST AVAILABLE, FLEXIBLE</p>

      <div style="overflow: hidden;">
        <button class="k-button cvt-primary cvt-kendobutton" value="save" (click)="saveBarKeywords()">Save Changes</button>
        <button class="k-button cvt-kendobutton-cancel " value="default" (click)="loadDefaultBARKeywords()">Load Default</button>
      </div>
    </ng-template>
    <ng-template ngl-tab id="rateAuditSettings" label="Rate Audit Settings" *ngIf="hasRateAuditAccess">
      <table>
        <tr>
          <td class="col-header col33">Date Range Selection Rule</td>
          <td class="spacer-column">&nbsp;</td>
          <td class="col-header col67">Single Season Processing Date Selection</td>
        </tr>
        <tr class="spacer-row"><td colspan="2"></td></tr>
        <tr>
          <td class="top-align">
            <table>
              <tr *ngFor="let select of dateRangeSelectArray let i = index">
                <td class="dateRangeSelectionLabel">{{i+1}})</td>
                <td>
                  <kendo-dropdownlist
                    #list
                    [data]="dateRangeNumberSelection"
                    [value]="select.number"
                    [valuePrimitive]="false"
                    [textField]="'text'"
                    [valueField]="'value'"
                    (selectionChange)="OnDateRangeNumberSelectionChanged($event, i)">
                    <ng-template kendoDropDownListValueTemplate>
                      <span class="boldFont"> {{dateRangeSelectArray[i].number.text}}</span>
                    </ng-template>
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                      <span>{{dataItem.text}}</span>
                    </ng-template>
                  </kendo-dropdownlist>
                </td>
                <td>
                    <kendo-dropdownlist
                      #list
                      [data]="dateRangeDaySelection"
                      [value]="select.day"
                      [valuePrimitive]="false"
                      [textField]="'text'"
                      [valueField]="'value'"
                      (selectionChange)="OnDateRangeDaySelectionChanged($event, i)">
                      <ng-template kendoDropDownListValueTemplate>
                        <span class="boldFont">{{dateRangeSelectArray[i].day.text}}</span>
                      </ng-template>
                      <ng-template kendoDropDownListItemTemplate let-dataItem>
                        <span>{{dataItem.text}}</span>
                      </ng-template>
                    </kendo-dropdownlist>
                  </td>
              </tr>
            </table>
          </td>
          <td class="spacer-column">&nbsp;</td>
          <td class="top-align">
            <table>
              <tr>
                <td colspan="4">
                    If a given hotel contains only one date range to audit, you must specify the months on which the audits will be performed.
                    Audits will be performed on these months by utilizing the Date Range Selection Rules.
                </td>
              </tr>
              <tr class="spacer-row"><td colspan="4"></td></tr>
              <tr>
                <td>
                  <ngl-checkbox label="January">
                    <input ngl type="checkbox" [(ngModel)]="this.rateAuditSettingsObj.MonJan" name="MonJan" />
                  </ngl-checkbox>
                </td>
                <td>
                  <ngl-checkbox label="April">
                    <input ngl type="checkbox" [(ngModel)]="this.rateAuditSettingsObj.MonApr" name="MonApr" />
                  </ngl-checkbox>
                </td>
                <td>
                  <ngl-checkbox label="July">
                    <input ngl type="checkbox" [(ngModel)]="this.rateAuditSettingsObj.MonJul" name="MonJul" />
                  </ngl-checkbox>
                </td>
                <td>
                  <ngl-checkbox label="October">
                    <input ngl type="checkbox" [(ngModel)]="this.rateAuditSettingsObj.MonOct" name="MonOct" />
                  </ngl-checkbox>
                </td>
              </tr>
              <tr>
                <td>
                  <ngl-checkbox label="February">
                    <input ngl type="checkbox" [(ngModel)]="this.rateAuditSettingsObj.MonFeb" name="MonFeb" />
                  </ngl-checkbox>
                </td>
                <td>
                  <ngl-checkbox label="May">
                    <input ngl type="checkbox" [(ngModel)]="this.rateAuditSettingsObj.MonMay" name="MonMay" />
                  </ngl-checkbox>
                </td>
                <td>
                  <ngl-checkbox label="August">
                    <input ngl type="checkbox" [(ngModel)]="this.rateAuditSettingsObj.MonAug" name="MonAug" />
                  </ngl-checkbox>
                </td>
                <td>
                  <ngl-checkbox label="November">
                    <input ngl type="checkbox" [(ngModel)]="this.rateAuditSettingsObj.MonNov" name="MonNov" />
                  </ngl-checkbox>
                </td>
              </tr>
              <tr>
                <td>
                  <ngl-checkbox label="March">
                    <input ngl type="checkbox" [(ngModel)]="this.rateAuditSettingsObj.MonMar" name="MonMar" />
                  </ngl-checkbox>
                </td>
                <td>
                  <ngl-checkbox label="June">
                    <input ngl type="checkbox" [(ngModel)]="this.rateAuditSettingsObj.MonJun" name="MonJun" />
                  </ngl-checkbox>
                </td>
                <td>
                  <ngl-checkbox label="September">
                    <input ngl type="checkbox" [(ngModel)]="this.rateAuditSettingsObj.MonSep" name="MonSep" />
                  </ngl-checkbox>
                </td>
                <td>
                  <ngl-checkbox label="December">
                    <input ngl type="checkbox" [(ngModel)]="this.rateAuditSettingsObj.MonDec" name="MonDec" />
                  </ngl-checkbox>
                </td>
              </tr>
              <tr class="spacer-row"><td colspan="4"></td></tr>
              <tr>
                <td colspan="4">
                    <app-configuration-keyword *ngIf='displayComparisonKeywords' (notify)='getMessage($event)' loadComparisonKeywords={{this.comparisonKeywords}}></app-configuration-keyword>
                </td>
              </tr>
            </table>
          </td>
        </tr>
    </table>
    <div style="overflow: hidden;">
      <button class="k-button cvt-primary cvt-kendobutton" value="save" (click)="saveRateAuditSettings()">Save Changes</button>
    </div>
    </ng-template>
  </ngl-tabset>
</form>
